import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=078231ac&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('078231ac')) {
      api.createRecord('078231ac', component.options)
    } else {
      api.reload('078231ac', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=078231ac&", function () {
      api.rerender('078231ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29Vr5jAPvAp2W/JS/pricehelp.vue"
export default component.exports